import { render } from "./RegistrationCompanyContractTabComponent.vue?vue&type=template&id=4f17ca52"
import script from "./RegistrationCompanyContractTabComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationCompanyContractTabComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__